import { render } from "./AboutNext.vue?vue&type=template&id=bae473ae&scoped=true"
import script from "./AboutNext.vue?vue&type=script&lang=js"
export * from "./AboutNext.vue?vue&type=script&lang=js"

import "./AboutNext.vue?vue&type=style&index=0&id=bae473ae&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae473ae"]])

export default __exports__